import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap"
import { Link } from "react-router-dom"
import "../../newcomponents/index.css"
import { useSelector } from "react-redux"
import config from "config/config"
import axios from "axios"

const Inbox = () => {
  
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const userData = useSelector(state => state.Login.userData)
  const mode = useSelector(state => state.Layout.layoutMode)

  const [doctors, setDoctors] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const doctorsPerPage = 4
  

  // Fetch Reviews and Doctors
  const fetchDoctors = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/healthgrade/getDoctors?integrationId=${
          isConsolidatedView
            ? organizations
                .map(org => org.Organization.HealthgradeIntegrations[0].id)
                .join(",")
            : activeOrganization.HealthgradeIntegrations[0].id
        }`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      setDoctors(response.data.doctors)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (activeOrganization?.HealthgradeIntegrations?.length) {
      fetchDoctors()
    }
  }, [activeOrganization, isConsolidatedView, organizations])

  // Pagination logic
  const validDoctors = Array.isArray(doctors) ? doctors : []
  const indexOfLastDoctor = currentPage * doctorsPerPage
  const indexOfFirstDoctor = indexOfLastDoctor - doctorsPerPage
  const currentDoctors = validDoctors.slice(
    indexOfFirstDoctor,
    indexOfLastDoctor,
  )
  const totalPages = Math.max(
    1,
    Math.ceil(validDoctors.length / doctorsPerPage),
  )

  const paginate = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber)
    }
  }

  return (
    <React.Fragment>
      <Card
        className="br"
        style={{
          display: "flex",
          minHeight: "460px",
          maxHeight: "460px",
          marginBottom: "1rem",
          flexDirection: "column",
        }}
      >
        <CardBody
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Row className="align-items-center">
            <Col xl={6} lg={6} md={6} className="d-flex align-items-center">
              <CardTitle
                className={`h4 mb-3 ${mode === "dark" ? "dark-text" : "light-text"}`}
              >
                Doctors List
              </CardTitle>
            </Col>
          </Row>

          {/* Doctors List - Scrollable with fixed height */}
          <div
            className="inbox-wid"
            style={{
              overflowY: "auto",
              minHeight: "300px",
              maxHeight: "300px",
              marginBottom: "1rem",
            }}
          >
            {currentDoctors.length > 0 ? (
              currentDoctors.map((doctor, key) => (
                <Link
                  key={key}
                  to="#"
                  className="text-dark text-decoration-none"
                >
                  <div className="inbox-item d-flex align-items-center border rounded p-3 mb-2 shadow-sm">
                    <div className="inbox-item-img me-3">
                      <img
                        src={doctor.doctorAvatar}
                        className="avatar-sm rounded-circle"
                        alt={doctor.doctorName}
                      />
                    </div>
                    <div>
                      <h6 className="mb-1 font-size-16 font-weight-bold">
                        {doctor.doctorName}
                      </h6>
                      <p className="text-muted mb-0">
                        {doctor.doctorSpeciality}
                      </p>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <p>No doctors available.</p>
            )}
          </div>

          {/* Pagination Controls */}
          <Pagination className="mb-0 justify-content-center mt-auto">
            <PaginationItem disabled={currentPage === 1}>
              <PaginationLink
                previous
                onClick={() => paginate(currentPage - 1)}
                style={{
                  color: mode === "dark" ? "#fff" : "#000",
                  backgroundColor: "transparent",
                  borderColor: mode === "dark" ? "#444" : "#dee2e6",
                }}
              />
            </PaginationItem>

            {Array.from({ length: totalPages }).map((_, i) => (
              <PaginationItem active={i + 1 === currentPage} key={i}>
                <PaginationLink
                  onClick={() => paginate(i + 1)}
                  style={{
                    borderColor:
                      i + 1 === currentPage
                        ? "#2990DF"
                        : mode === "dark"
                          ? "#444"
                          : "#dee2e6",
                    backgroundColor:
                      i + 1 === currentPage ? "#2990DF" : "transparent",
                    color:
                      i + 1 === currentPage
                        ? "#fff"
                        : mode === "dark"
                          ? "#fff"
                          : "#000",
                    boxShadow: "none",
                  }}
                >
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}

            <PaginationItem disabled={currentPage === totalPages}>
              <PaginationLink
                next
                onClick={() => paginate(currentPage + 1)}
                style={{
                  color: mode === "dark" ? "#fff" : "#000",
                  backgroundColor: "transparent",
                  borderColor: mode === "dark" ? "#444" : "#dee2e6",
                }}
              />
            </PaginationItem>
          </Pagination>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default Inbox
